import { render, staticRenderFns } from "./BalanceModal.vue?vue&type=template&id=1950e192&"
import script from "./BalanceModal.vue?vue&type=script&lang=js&"
export * from "./BalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports